
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const scheduledVisitApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getScheduledVisits: build.query<any, void>({
      query: () => ({
        url: appEndpoint.scheduledVisit,
        method: 'get',
      }),
      providesTags: ['ScheduledVisit'],
    }),
    getScheduledVisitById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.scheduledVisit}/${id}`,
        method: 'get',
      }),
      providesTags: ['ScheduledVisit'],
    }),
    updateStatus: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.scheduledVisit}/${data.id}/status` ,
        method: 'patch',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["ScheduledVisit"] : []),
    }),

   

  }),
  overrideExisting: false,
});

export const {
  useGetScheduledVisitsQuery,
  useGetScheduledVisitByIdQuery,
  useUpdateStatusMutation
} = scheduledVisitApi;